import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import API from '../api'

import FaRotate from 'react-icons/fa/repeat'
import FaSpinner from 'react-icons/fa/spinner'

@autobind
class WorkMediaRotation extends Component {
  constructor (props) {
    super(props)
    this.state = { pending: false, checked: false }
  }

  rotateMedia (degrees) {
    this.setState({pending: true, checked: false})
    API.put(`/v3/media/${this.props.medium.id}/rotate?include=medium.image`, {degrees})
    .then(response => {
      this.props.onImageRotation(response.data.medium.image_url + '?v=' + Date.now(), this.props.index)
      this.setState({pending: false})
    })
  }

  handleMenuChange (event) {
    this.setState({checked: !this.state.checked})
  }

  render () {
    return (
      <div className={this.state.pending ? 'workMedia__rotate workMedia__rotate--pending' : 'workMedia__rotate'}>
        <label className='btn btn-overlay' htmlFor={'trigger--' + this.props.medium.id}>{!this.state.pending ? <FaRotate /> : <FaSpinner /> }{!this.state.pending ? ' Rotate' : ''}</label>
        <input type='checkbox' id={'trigger--' + this.props.medium.id} onChange={this.handleMenuChange} checked={this.state.checked} hidden />
        <div className='dropdown__menu dropdown__menu--right dropdown__menu--bottom'>
          <ul>
            <li><button onClick={() => this.rotateMedia('90')}>Rotate 90°</button></li>
            <li><button onClick={() => this.rotateMedia('180')}> Rotate 180°</button></li>
            <li><button onClick={() => this.rotateMedia('270')}> Rotate 270°</button></li>
          </ul>
        </div>
      </div>
    )
  }
}

export default WorkMediaRotation

WorkMediaRotation.propTypes = {
  medium: PropTypes.object,
  index: PropTypes.number,
  onImageRotation: PropTypes.func
}



// WEBPACK FOOTER //
// ./components/work/WorkMediaRotation.js